export default __webpack_public_path__ + "static/media/5.280939a5.png";